import { render, staticRenderFns } from "./CustomerServices.vue?vue&type=template&id=e0c5d0e2&scoped=true"
import script from "./CustomerServices.vue?vue&type=script&lang=js"
export * from "./CustomerServices.vue?vue&type=script&lang=js"
import style0 from "./CustomerServices.vue?vue&type=style&index=0&id=e0c5d0e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0c5d0e2",
  null
  
)

export default component.exports